import { useParticipantViewContext } from "@stream-io/video-react-sdk";
import React from "react";
import Raisehand from "../../assets/svg/RaisHand.svg";

const CustomLocalParticpantView = () => {
  const { participant } = useParticipantViewContext();

  return (
    <div title={participant.name} hidden>
      <span>{participant.name}</span>
      <img src={participant.image} alt={participant.userId} />
      <div className="absolute top-0 right-4">
        {participant.reaction?.emoji_code === ":raise-hand:" ? (
          <img className="w-[24px] h-[24px]" src={Raisehand} alt="raisehand" />
        ) : null}
      </div>
    </div>
  );
};

export default CustomLocalParticpantView;
